import { render, staticRenderFns } from "./TenantAdmin.vue?vue&type=template&id=5ac427df&"
import script from "./TenantAdmin.vue?vue&type=script&lang=js&"
export * from "./TenantAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TenantAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports